var _path, _path2, _path3, _path4, _g, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarMan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.4514 41.5482C67.0681 25.835 57.2619 10.165 41.5486 6.54825C25.8354 2.93154 10.1653 12.7377 6.54863 28.451C2.93192 44.1642 12.7381 59.8343 28.4514 63.451C44.1646 67.0677 59.8347 57.2615 63.4514 41.5482Z",
    fill: "#005099",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_4817",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 60,
    height: 60
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4514 41.5482C67.0681 25.835 57.2619 10.1649 41.5486 6.54824C25.8354 2.93153 10.1653 12.7377 6.54863 28.451C2.93192 44.1642 12.7381 59.8343 28.4514 63.451C44.1646 67.0677 59.8347 57.2615 63.4514 41.5482Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_4817)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4_4817",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 58,
    height: 58
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0648 41.9346C66.895 26.4349 57.435 10.7649 41.9352 6.93464C26.4355 3.10441 10.7655 12.5644 6.93524 28.0642C3.10501 43.5639 12.565 59.2339 28.0648 63.0642C43.5645 66.8944 59.2345 57.4344 63.0648 41.9346Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4_4817)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4_4817",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 60,
    height: 60
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5491 41.4506C67.1118 25.6834 57.2181 10.0134 41.4509 6.45063C25.6837 2.88789 10.0137 12.7816 6.45091 28.5488C2.88817 44.316 12.7819 59.9861 28.5491 63.5488C44.3163 67.1116 59.9863 57.2179 63.5491 41.4506Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4_4817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1561 12.852C29.1561 12.852 33.2486 7.30904 40.553 10.9871C48.5307 15.0796 44.231 23.8344 44.231 23.8344L27.084 20.6226L29.1561 12.852Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.737 23.886C25.737 23.886 21.2301 15.0794 29.1561 12.8518L30.6066 17.5659L25.737 23.886Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5705 27.979C29.6223 29.7403 28.2236 31.1908 26.4623 31.2426C24.701 31.2944 23.2505 29.8957 23.1987 28.1344C23.1469 26.3731 24.5456 24.9226 26.3069 24.8708C28.0164 24.819 29.5187 26.2177 29.5705 27.979Z",
    fill: "#E8B499"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5469 27.6171C24.5469 27.6171 25.7902 26.9955 27.0335 29.223",
    stroke: "#C47268",
    strokeWidth: 0.6887,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2266 28.0812C41.2266 29.8425 42.6771 31.2931 44.4384 31.2931C46.1997 31.2931 47.6502 29.8425 47.6502 28.0812C47.6502 26.3199 46.1997 24.8694 44.4384 24.8694C42.6253 24.8694 41.2266 26.3199 41.2266 28.0812Z",
    fill: "#E8B499"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2004 27.5636C46.2004 27.5636 44.9053 26.9937 43.7656 29.2213",
    stroke: "#C47268",
    strokeWidth: 0.6887,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4644 35.4369C39.4644 35.4369 37.6512 36.732 36.0453 37.0428C34.3876 37.3536 32.8335 36.4212 32.7817 36.3694L30.8649 35.2815L30.0879 45.7977L30.2951 45.9531C33.0925 48.2324 37.0814 48.2842 39.8788 46.0049L40.2932 45.694L39.4644 35.4369Z",
    fill: "#E8B499"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0879 34.1428C30.0879 34.1428 31.901 39.9966 35.9935 39.9448C39.3608 39.893 39.9306 34.1428 39.9306 34.1428H30.0879Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9719 22.4871C43.9719 26.1134 43.5057 29.2216 42.9876 31.3973C42.4696 33.5731 40.6047 35.0754 38.5843 36.3187L38.2217 36.5259C36.0978 37.821 34.3364 37.8728 32.2125 36.6295C30.0367 35.3862 28.0164 33.7285 27.5501 31.4491C26.6695 27.253 26.5659 22.5389 26.5659 22.5389C26.5659 22.5389 25.3226 12.7998 34.7509 12.9034C44.1273 13.1106 43.9719 22.4871 43.9719 22.4871Z",
    fill: "#E8B499"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0053 25.3906C32.0053 25.805 31.6427 26.1676 31.2282 26.1676C30.8138 26.1676 30.4512 25.805 30.4512 25.3906C30.4512 24.9762 30.8138 24.6135 31.2282 24.6135C31.6427 24.6135 32.0053 24.9243 32.0053 25.3906Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4643 25.3906C39.4643 25.805 39.1016 26.1676 38.6872 26.1676C38.2728 26.1676 37.9102 25.805 37.9102 25.3906C37.9102 24.9762 38.2728 24.6135 38.6872 24.6135C39.1016 24.6135 39.4643 24.9243 39.4643 25.3906Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2852 27.3577V28.5492H35.2694",
    stroke: "#C47268",
    strokeWidth: 0.6887,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3789 22.1784L33.3521 21.7121C33.3521 21.7121 32.8858 20.417 30.9173 20.6243C28.8451 20.8315 28.3789 22.1784 28.3789 22.1784Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2251 22.1784L36.252 21.7121C36.252 21.7121 36.7182 20.417 38.6867 20.6243C40.7589 20.8315 41.2251 22.1784 41.2251 22.1784Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5742 30.3127H37.4956C37.4956 30.3127 37.2884 31.8151 34.9572 31.8151C32.6778 31.8151 32.5742 30.3127 32.5742 30.3127Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8769 27.2016C26.8769 27.2016 27.2395 15.2349 27.0841 14.9241C27.0841 14.9241 22.888 18.8093 26.8769 27.2016Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6612 27.1495L43.0396 14.1467C42.9877 14.1467 47.0802 18.1874 43.6612 27.1495Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8141 13.8362C30.8141 13.8362 27.9131 14.6132 28.0167 17.5142C28.1203 20.3635 26.2036 23.2127 26.2036 23.2127L25.3229 20.3635C25.2711 20.3117 24.5977 14.9759 30.8141 13.8362Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0888 14.0965C30.0888 14.0965 32.2646 12.8532 34.4404 15.5988C36.3053 17.93 41.1748 20.3129 44.0759 18.0336C44.0759 18.0336 42.2109 11.4545 35.062 11.5581C27.9131 11.6617 30.0888 14.0965 30.0888 14.0965Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8231 67.9194H10.4023C11.283 64.1895 12.2155 60.8741 13.1479 58.2839C14.4948 54.4504 16.4634 52.2228 18.0693 50.9278C19.6752 49.6327 20.9703 49.3218 20.9703 49.3218L24.3894 47.8713H46.0951L49.2551 49.27C49.2551 49.27 54.3319 50.5651 57.0775 58.1803C57.9582 60.8223 58.8906 64.1377 59.8231 67.9194Z",
    fill: "#EF758D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4757 43.3127L46.0437 47.9233C46.0437 47.9233 35.1649 57.766 24.3379 47.9233L35.4757 43.3127Z",
    fill: "#E8B499"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3906 47.8713C24.3906 47.8713 28.1723 52.3265 35.2176 52.3265C42.2629 52.3265 46.0964 47.8713 46.0964 47.8713",
    stroke: "white",
    strokeWidth: 1.9384,
    strokeMiterlimit: 10
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0567 5.79785C21.7819 5.82262 9.79077 14.9594 6.68544 28.4509C3.06873 44.1642 12.8749 59.8342 28.5882 63.4509C30.7557 63.9498 32.9224 64.1933 35.0567 64.2011V5.79785Z",
    fill: "#9CC4D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hue"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4517 48.5481C54.835 64.2613 39.1648 74.068 23.4517 70.4514C22.6348 70.2634 21.8342 70.0408 21.0503 69.7893H34.9194V13.2229C35.4619 13.3161 36.0053 13.4231 36.5483 13.5481C52.2615 17.1648 62.0681 32.835 58.4517 48.5481ZM2.09521 50.5979C0.62548 45.8437 0.351838 40.65 1.54834 35.4514C1.70717 34.7614 1.89091 34.0829 2.09521 33.4163V50.5979Z",
    fill: "#9CC4D8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarMan);
export default __webpack_public_path__ + "static/media/avatar-man.f2aab0b30a8bc64288aeb3bcf1bb324a.svg";
export { ForwardRef as ReactComponent };